import { make } from 'vuex-pathify';
const state = {
  documentationDialog: false,
  newDocDialog: false,
  documentPreviewDialog: false,
  data: null,
  preview: null,
};

const getters = {
  ...make.getters(state),
};

const actions = {
  ...make.actions(state),
  openDocumentationDialog(context, data) {
    context.commit('SET_DOCUMENTATION_DIALOG', true);
    context.commit('SET_DATA', data);
  },
  openNewDocsDialog(context, data) {
    context.commit('SET_NEW_DOC_DIALOG', true);
    context.commit('SET_DATA', data);
  },
  openDocumentPreviewDialog(context, data) {
    context.commit('SET_DOCUMENT_PREVIEW_DIALOG', true);
    context.commit('SET_PREVIEW', data);
  }
};

const mutations = {
  ...make.mutations(state),
  SET_DOCUMENTATION_DIALOG(state, value) {
    state.documentationDialog = value;
  },
  SET_DOCUMENT_PREVIEW_DIALOG(state, value) {
    state.documentPreviewDialog = value;
  },
  SET_NEW_DOC_DIALOG(state, value) {
    state.newDocDialog = value;
  },
  SET_DATA(state, value) {
    state.data = value;
  },
  SET_PREVIEW(state, value) {
    state.preview = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
